import { useState } from "react"
import { AbsoluteContainer, AppSpan, AppText, CustomContainer, FlexRow } from "src/style"
import { AppTable } from "src/component/AppTable"
import { chatColumns, callColumns, scheduledCallColumns, chatData, callData, scheduledCallData } from "src/utils/tableLayout"
import { ConversationChats } from "src/component"


export const Conversations: React.FC<any> = () => {
    const [isChats, setIsChats] = useState(false)
    const [chatInfo, setChatInfo] = useState<any>(null)
    const [navPosition, setNavPosition] = useState(0)

    function handleSelectedConversation (rowData: any) {
        setChatInfo(rowData)
        setIsChats(true)
    }

    return (
        <>
            { !isChats &&
                <CustomContainer>
                    <AppText textSize="1.8" fontWeight="700" color="#27272E" topMargin="3">Conversations</AppText>
                    <CustomContainer 
                        height="2.7" width="30" topMargin="2.5" bottomMargin="2.5"
                        style={{borderBottom: '1px solid #EDF2F7'}}
                    >
                        <AbsoluteContainer bottom="0" left={`${navPosition}`}>
                            <CustomContainer bgColor="#4C6FFF" width={navPosition === 17.7 ? '10' : "5"} height="0.3" />
                        </AbsoluteContainer>
                        <FlexRow gap="3.5">
                            <AppSpan 
                                color={navPosition === 0 ? "#1A202C" : "#A0AEC0"}
                                textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                onClick={() => setNavPosition(0)}
                            >
                                Chats
                            </AppSpan>
                            <AppSpan 
                                color={navPosition === 9 ? "#1A202C" : "#A0AEC0"}
                                textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                onClick={() => setNavPosition(9)}
                            >
                                Calls
                            </AppSpan>
                            <AppSpan 
                                color={navPosition === 17.7 ? "#1A202C" : "#A0AEC0"}
                                textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                                onClick={() => setNavPosition(17.7)}
                            >
                                Scheduled calls
                            </AppSpan>
                        </FlexRow>
                    </CustomContainer>
                    <AppTable
                        columns={navPosition === 0 ? chatColumns : navPosition === 9 ? callColumns : scheduledCallColumns} 
                        data={navPosition === 0 ? chatData : navPosition === 9 ? callData: scheduledCallData}
                        onRowClick={handleSelectedConversation}
                        rowHeight='7.9'
                    />
                </CustomContainer>
            }
            { isChats &&
                <ConversationChats 
                    back={() => setIsChats(false)}
                    data={chatInfo}
                />
            }
        </>
    )
}